<!-- From Dialog -->
<ng-container *ngIf="data.isDialog">
  <div class="block mx-auto modal-box">
    <div class="modal1">
      <button title="Close (Esc)" type="button" class="mfp-close mt-1 m-r-15" (click)="onCloseDialog()">×</button>
        <div class="p-4">
          <div class="fancy-title m-b-20">
            <h4>{{ 'Edit Card' | translate }}</h4>
          </div>
          <ng-container *ngTemplateOutlet="formContent"></ng-container>
      </div>
    </div>
  </div>
</ng-container>

<!-- Non Dialog -->
<ng-container *ngIf="!data.isDialog">
  <ng-container *ngTemplateOutlet="formContent"></ng-container>
</ng-container>


<ng-template #formContent>
  <!-- Form Content -->
  <form class="row" [formGroup]="form" id="bank-modal-form" name="bank-modal-form">
    <div class="form-group pr-0" [ngClass]="{'col-md-12': data.isDialog, 'col-md-6': !data.isDialog}">
      <!-- Card Holder Name -->
      <label>{{ 'Card Holder Name' | translate }}: </label>
      <div class="row">
        <div class="col">
          <input class="form-control" type="text" placeholder="{{ 'Enter Card Holder Name' | translate }}" [value]="userData.name" readonly />
        </div>
      </div>
    </div>
    <div class="form-group pr-0" [ngClass]="{'col-md-12': data.isDialog, 'col-md-6': !data.isDialog}">
      <!-- Card Number -->
      <label>{{ 'Card Number' | translate }}: </label>
      <div class="row">
        <div class="col">
          <input class="form-control" type="text" formControlName="card_number" [ngClass]="{'is-invalid': checkValidity && form.controls.card_number.errors }" placeholder="0000 0000 0000 0000" (keypress)="allowOnlyNumbers($event)" #cardInput>
        </div>
      </div>
    </div>
    <div class="form-group pr-0" [ngClass]="{'col-md-12': data.isDialog, 'col-md-6': !data.isDialog}">
      <!-- Expiry Date -->
      <label>{{ 'Expiry Date' | translate }}: </label>
      <div class="row">
        <div class="col">
          <input class="form-control" type="text" formControlName="expiry_date" [ngClass]="{'is-invalid': checkValidity && form.controls.expiry_date.errors }" placeholder="{{ '(MM/YY)' | translate }}" #expiryInput>
        </div>
      </div>
    </div>

    <!-- Save Button -->
    <div class="col-12 text-center" *ngIf="!data.isDialog">
      <button class="button-blue" [ngClass]="{'disabled': disabledButton || !form.valid}" [disabled]="disabledButton || !form.valid" (click)="onSubmit()" >{{ 'Save' | translate }}</button>
    </div>

    <!-- Update & Remove Button -->
    <div class="col-12 d-flex mt-2" *ngIf="data.isDialog">
      <button class="button-blue flex-fill mr-1" [ngClass]="{'disabled': disabledButton || !form.valid}" [disabled]="disabledButton || !form.valid" (click)="onSubmit()" >{{ 'UPDATE CARD' | translate }}</button>
      <button class="button-orange flex-fill ml-1" (click)="onRemove()" >{{ 'REMOVE CARD' | translate }}</button>
    </div>
  </form>

  <!-- My Credit Cards Section -->
  <div class="row" *ngIf="cards.length > 0 && !data.isDialog">
    <hr>
    <div class="col-md-12">
      <label for="">{{ 'My Credit Cards' | translate | uppercase }}</label>
    </div>
    <div class="col-md-6 m-b-20" *ngFor="let card of cards">
      <div class="bankDetails-input">
        <div class="row mx-auto">
          <div class="col-2 p-0 d-flex justify-content-center">
            <img [src]="'assets/images/credit-card/' + card.card_brand + '.png'">
          </div>
          <div class="col-8 d-flex align-items-center">
            <p class="m-0">{{ card.brand_name }} &#x2022;&#x2022;&#x2022;&#x2022; &#x2022;&#x2022;&#x2022;&#x2022; &#x2022;&#x2022;&#x2022;&#x2022; {{ card.last_four }} {{ card.expiry_month }}/{{ card.expiry_year }}</p>
          </div>
          <div class="col-2 pr-0 pl-3">
            <button class="button-blue edit-button-button" (click)="onEdit(card)">
              <img src="assets/images/edit.png" class="edit-button" alt="Button Icon">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-swal-alert [success]="isSuccess" [message]="messages$ | async" (confirmed)="onCloseDialog($event)"></app-swal-alert>